// dashboard-model.js

import { Model } from 'backbone';
import Immutable from 'immutable';

class FormDetailsModel extends Model {

    initialize() {
       
    }

    defaults() {
        return {};
    }


    parse(response, options)  {
        return response;
    }
}

export default FormDetailsModel;
